import React from 'react';
import styles from './styles.module.scss';
export default function SkeletonSupplierCard() {
  return <div className={styles.card} data-sentry-component="SkeletonSupplierCard" data-sentry-source-file="index.tsx">
      <div className={styles.imagePlaceholder} />
    </div>;
}